export default __webpack_public_path__ + "static/media/PC-Color.fd2a8311.png";